import React, { useState, useEffect, useContext } from "react";
import { Heart, Trash2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../../assests/css/customer/WishlistPage.css";
import MyNavbar from "../../../components/Customer/Mynavbar/MyNavbar";
import Footer from "../../../components/Customer/Footer/Footer";
import ProductCard from "../../../components/Customer/ProductCard/ProductCard";
import AppContext from "../../../context/AppContext";

const WishlistPage = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { baseUrl, setWishlistCount, requireLogin } = useContext(AppContext);

  const customer = JSON.parse(localStorage.getItem("loggedInCustomer"));
  const customerId = customer?.id;

  const [wishlistItems, setWishlistItems] = useState([]);

  useEffect(() => {
    if (!customerId) {
      setWishlistItems([]);
      setWishlistCount(0);
      setLoading(false);
      return;
    }

    axios
      .get(`${baseUrl}/customer/wishlists/GetAllwishlist/${customerId}`)
      .then((res) => {
        const wishlists = res.data.wishlists || [];
        setWishlistItems(wishlists);
        setWishlistCount(wishlists.length);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setWishlistItems([]);
        setWishlistCount(0);
        setLoading(false);
      });
  }, [customerId, baseUrl]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "80px 0" }}>
        <div
          style={{
            width: "50px",
            height: "50px",
            border: "5px solid #f3e8d8",
            borderTop: "5px solid #E3CAA5",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            margin: "0 auto",
          }}
        ></div>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!customerId) {
    return (
      <>
        <MyNavbar />
        <br />
        <br />
        <div className="wishlist-container">
          <div className="wishlist-page">
            <div className="wishlist-empty">
              <h2>Please Login</h2>
              <p>Login to view and manage your wishlist</p>
              <button
                className="wishlist-continue-btn"
                onClick={() => navigate("/login")}
              >
                Login
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <MyNavbar />

      <br />
      <br />

      <div className="wishlist-container">
        <div className="wishlist-page">

          {/* HEADER */}
          <div className="wishlist-header">
            <div className="wishlist-title-section">
              <Heart
                size={32}
                fill="currentColor"
                className="wishlist-icon-header"
              />
              <h1 className="wishlist-title">My Wishlist</h1>
              <span className="wishlist-count">
                {wishlistItems.length} items
              </span>
            </div>
            {wishlistItems.length > 0 && (
              <button
                className="wishlist-clear-btn"
                onClick={async () => {
                  if (!requireLogin()) return;
                  try {
                    await Promise.all(
                      wishlistItems.map((item) => {
                        const formData = new FormData();
                        formData.append("wishlist_id", item.id);
                        return axios.post(
                          `${baseUrl}/customer/wishlists/deleteWishlist`,
                          formData
                        );
                      })
                    );
                    setWishlistItems([]);
                    setWishlistCount(0);
                  } catch (err) {
                    console.error(err);
                  }
                }}
              >
                <Trash2 size={20} />
                Clear All
              </button>
            )}
          </div>

          {/* EMPTY STATE */}
          {wishlistItems.length === 0 ? (
            <div className="wishlist-empty">
              <div className="wishlist-empty-cartoon">
                <div className="wishlist-cartoon-face">
                  <div className="wishlist-cartoon-eyes">
                    <div className="wishlist-eye">
                      <div className="wishlist-tear"></div>
                    </div>
                    <div className="wishlist-eye">
                      <div className="wishlist-tear"></div>
                    </div>
                  </div>
                  <div className="wishlist-cartoon-mouth"></div>
                </div>
              </div>
              <h2>Your Wishlist is Empty</h2>
              <p>Save your favorite items here and shop them later!</p>
              <a href="/" className="wishlist-continue-btn">
                Continue Shopping
              </a>
            </div>
          ) : (
            <div className="wishlist-grid">
              {wishlistItems.map((item) => {
                return (
                  <div key={item.id} className="wishlist-card-wrapper">
                    <ProductCard
                      product={{
                        id: item.mlproduct_id,
                        name: item.product?.name || "No Name",
                        base_price: item.product?.base_price || 0,
                        price: item.product?.base_price || 0,
                        images: item.product?.images || [],
                        enable_sale: item.product?.enable_sale,
                        discount_price: item.product?.discount_price,
                      }}
                      type={item.product?.type}
                      wishlist={wishlistItems.map((w) => w.mlproduct_id)}
                      toggleWishlist={async () => {
                        if (!requireLogin()) return;
                        try {
                          const formData = new FormData();
                          formData.append("wishlist_id", item.id);
                          const res = await axios.post(
                            `${baseUrl}/customer/wishlists/deleteWishlist`,
                            formData
                          );
                          if (res.data.success) {
                            setWishlistItems((prev) =>
                              prev.filter((w) => w.id !== item.id)
                            );
                            setWishlistCount((prev) => prev - 1);
                          }
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      onCardClick={() =>
                        navigate(`/product-detail/${item.mlproduct_id}`)
                      }
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default WishlistPage;